
export const companyInfo = {
  name: "Arham Exports",
  tagline: "The Pharmaceutical, Food and Chemical Distribution Partner",
  description: "Arham Exports is a bridge between Indian producers and local industries, facilitating innovation and development by supplying essential Pharmaceutical, Food and Chemical products to the markets that need them most.",
  aboutUsDescription: `
    <p>We at Arham Exports aim to become <b>the Pharmaceutical, Food and Chemical distribution partner of choice</b> for manufacturers all over the India. Our customers’ interests and reputations are our highest priority. We work to protect them by our own continuous improvement.</p><br/>
    <p>We continually work to identify new products and sources as part of our commitment to bring <b>innovation</b> to our entire customer network. We give flexibility, reliability and professionalism needed to fuel growth and market expansion.</p><br/>
    <p>As trusted chemical distributors, we represent renowned Indian manufacturers, extending their reach and ensuring local markets have access to the high-quality materials they deserve.</p><br/>
    <p><b>We are the bridge between Indian producers and local industries, facilitating innovation and development by supplying essential Pharmaceutical, Food and chemical products to the markets that need them most.</b></p><br/>
    <p>With a robust domestic and international network, we are committed to being the reliable partner for our customers, offering global reach with local insights. In a challenging marketplace, <b>Arham Exports</b> stands as your partner in advancing industrial capabilities efficiently and effectively.
  `,
  stats: [
    { label: "Years of Experience", value: 25, suffix: "+" },
    { label: "Countries Served", value: 50, suffix: "+" },
    { label: "Happy Clients", value: 500, suffix: "+" },
    { label: "Products", value: 1200, suffix: "+" },
  ],
  vision: "To be the most trusted global partner in the pharmaceutical supply chain, ensuring equitable access to quality healthcare solutions worldwide.",
  mission: "We are committed to delivering excellence through integrity, innovation, and unparalleled service, ensuring that our partners receive the best quality products on time, every time.",
  goals: [
    "Expand our global footprint to 100+ countries by 2030.",
    "Achieve carbon neutrality in our logistics operations.",
    "Foster long-term partnerships with sustainable manufacturers.",
    "Continuously innovate our supply chain management systems."
  ]
};

export const boardMembers = [
  {
    id: 1,
    name: "Rajesh Mehta",
    role: "Chairman & Founder",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&q=80&w=400&h=400",
    bio: "With over 40 years in the pharma industry, Rajesh brings wisdom and strategic vision."
  },
  {
    id: 2,
    name: "Suresh Patel",
    role: "Managing Director",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=400&h=400",
    bio: "Suresh leads the global operations with a focus on efficiency and expansion."
  },
  {
    id: 3,
    name: "Anita Desai",
    role: "Director of Quality",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=400&h=400",
    bio: "Anita ensures that every product leaving our warehouse meets international standards."
  }
];

export const products = [
  {
    id: 1,
    name: "Microcrystalline Cellulose",
    category: "101, 102, 103, 105, 112",
    industryDetails:[
      { name: "Pharmaceuticals Functional Application", functionalApplication: "<p>Binder / Diluent</p><p>Disintegrant</p><p>Bulking Agent</p><p>Adsorbent/Suspending Agent</p><p>Lubricant/Anti-adherent</p>" },
      { name: "Food Functional Application", functionalApplication: "<p>Fat Replacement & Texture Support</p><p>Anti-Caking Agent</p><p>Stabilizer & Emulsifier</p><p>Thickener & Bulking Agent</p>" }
    ]
  },
  {
    id: 2,
    name: "Hydroxypropyl Methylcellulose",
    category: "E5, E15, K4M, K100M",
    industryDetails:[
      { name: "Pharmaceuticals Functional Application", functionalApplication: "<p>Film Coating Agent</p><p>Controlled / Sustained Release Agent</p><p>Tablet Binding</p><p>Capsule Shells</p><p>Thickening & Suspending</p>" },
      { name: "Food Functional Application", functionalApplication: "<p>Thickening & Stabilization</p><p>Emulsification</p><p>Texture Enhancement</p><p>Moisture Retention</p><p>Glazing & Coating</p>" },
      { name: "Cosmetics Functional Application", functionalApplication: "<p>Thickening & Rheology Control</p><p>Film Forming</p><p>Emulsion Stabilization</p><p>Binding</p><p>Foam Stabilization</p>" }
    ]
  },
  {
    id: 3,
    name: "Magnesium Stearate",
    category: "",
    industryDetails: [
      {
        name: "Pharmaceuticals & Nutraceuticals Functional Application",
        functionalApplication: "<p>Lubricant Agent</p><p>Flow Agent</p><p>Binder</p>"
      },
      {
        name: "Food Functional Application",
        functionalApplication: "<p>Anti-Caking Agent</p><p>Emulsifier & Thickener</p>"
      },
      {
        name: "Cosmetics & Personal Care Functional Application",
        functionalApplication: "<p>Texturizer</p><p>Anti-Caking Agent</p>"
      }
    ]
  },
  {
    id: 4,
    name: "Croscarmellose Sodium",
    category: "",
    industryDetails: [
      {
        name: "Pharmaceuticals Functional Application",
        functionalApplication: "<p>Tablet & Capsule Disintegrant</p>"
      }
    ]
  }
];

export const foodColoursProducts = [
  {
    id: 1,
    name: "Caramel Colour",
    category: "Natural Food Colours",
    industry: "Food Industry"
  },
  {
    id: 2,
    name: "Annatto Colour",
    category: "Natural Food Colours",
    industry: "Food Industry"
  },
  ,
  {
    id: 3,
    name: "Beetroot Colour",
    category: "Natural Food Colours",
    industry: "Food Industry"
  },
  ,
  {
    id: 4,
    name: "Curcumin Colour",
    category: "Natural Food Colours",
    industry: "Food Industry"
  },
  ,
  {
    id: 5,
    name: "Chlorophyll Colour",
    category: "Natural Food Colours",
    industry: "Food Industry"
  },
  {
    id: 6,
    name: "Banana Powder",
    category: "Spray Dried Fruit Powder",
    industry: "Food Industry"
  },
  {
    id: 7,
    name: "Strawberry Powder",
    category: "Spray Dried Fruit Powder",
    industry: "Food Industry"
  },
  {
    id: 8,
    name: "Mango Powder",
    category: "Spray Dried Fruit Powder",
    industry: "Food Industry"
  },
  {
    id: 9,
    name: "Custard Apple Powder",
    category: "Spray Dried Fruit Powder",
    industry: "Food Industry"
  },
  {
    id: 10,
    name: "Guava Powder",
    category: "Spray Dried Fruit Powder",
    industry: "Food Industry"
  },
  {
    id: 11,
    name: "Pineapple Powder",
    category: "Spray Dried Fruit Powder",
    industry: "Food Industry"
  },
  {
    id: 12,
    name: "Orange Powder",
    category: "Spray Dried Fruit Powder",
    industry: "Food Industry"
  },
  {
    id: 13,
    name: "Tomato Powder",
    category: "Spray Dried Vegetable Powder",
    industry: "Food Industry"
  },
  {
    id: 14,
    name: "Lemon Powder",
    category: "Spray Dried Vegetable Powder",
    industry: "Food Industry"
  },
  {
    id: 15,
    name: "Ginger Powder",
    category: "Spray Dried Vegetable Powder",
    industry: "Food Industry"
  },
  {
    id: 16,
    name: "Tamarind Powder",
    category: "Spray Dried Vegetable Powder",
    industry: "Food Industry"
  },
  {
    id: 17,
    name: "Garlic Powder",
    category: "Spray Dried Vegetable Powder",
    industry: "Food Industry"
  },
  {
    id: 18,
    name: "Onion Powder",
    category: "Spray Dried Vegetable Powder",
    industry: "Food Industry"
  },
  {
    id: 19,
    name: "Spinach Powder",
    category: "Spray Dried Vegetable Powder",
    industry: "Food Industry"
  },
  {
    id: 20,
    name: "Hydrolized Vegetable Protein (HVP)",
    category: "Speciality Ingredients",
    industry: "Food Industry"
  },
  {
    id: 21,
    name: "Cheese Powder",
    category: "Speciality Ingredients",
    industry: "Food Industry"
  },
  {
    id: 22,
    name: "Buttermilk Powder",
    category: "Speciality Ingredients",
    industry: "Food Industry"
  },
  {
    id: 23,
    name: "Fat Powder",
    category: "Speciality Ingredients",
    industry: "Food Industry"
  },
  {
    id: 24,
    name: "Non-Dairy Creamer",
    category: "Speciality Ingredients",
    industry: "Food Industry"
  },
  {
    id: 25,
    name: "Curd Powder",
    category: "Speciality Ingredients",
    industry: "Food Industry"
  }
];

export const certifications = [
  {
    id: 1,
    name: "ISO 9001:2015",
    issuer: "International Organization for Standardization",
    icon: "Award",
    image: "https://images.unsplash.com/photo-1635350736475-c8cef4b21906?auto=format&fit=crop&q=80&w=800&h=600" 
  },
  {
    id: 2,
    name: "WHO GMP",
    issuer: "World Health Organization",
    icon: "ShieldCheck",
    image: "https://images.unsplash.com/photo-1581093458791-9f302e6d862e?auto=format&fit=crop&q=80&w=800&h=600"
  },
  {
    id: 3,
    name: "FDA Registered",
    issuer: "U.S. Food and Drug Administration",
    icon: "FileCheck",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&q=80&w=800&h=600"
  },
  {
    id: 4,
    name: "AEO Certified",
    issuer: "Customs",
    icon: "Globe",
    image: "https://images.unsplash.com/photo-1566576912904-800a758e560d?auto=format&fit=crop&q=80&w=800&h=600"
  }
];
